import { compareVersion } from '@utils/compare-version';
import getAppVersion from '@utils/ua/get-app-version';
import { isMeetingApp } from '@utils/ua/is-mobile';
import { useEffect, useLayoutEffect } from 'react';

/** promise 等待 n 毫秒 */
export const sleep = (n: number) => new Promise((res) => setTimeout(res, n));

/** webview location 跳转默认会让左上角返回按钮变成关闭,每次打开页面时可以用这个方法
 * 由于这个方法耦合了 3 个功能,需要谨慎使用 https://iwiki.woa.com/pages/viewpage.action?pageId=4008231321
 */
export const enableMeetingAppBack = (title?: string) => {
  if (!isMeetingApp() || typeof wemeet === 'undefined') return;
  wemeet.ui.setHeaderView({
    mixBackExitButton: true,
    showRefresh: false,
    title: title || document.title,
    rightButton: {
      text: '',
    },
  });
};

/** hook 用法 */
export const useEnableMeetingAppBack = () => {
  useLayoutEffect(() => {
    enableMeetingAppBack();
  }, []);
};

export const disableWebviewBounds = (resetOnLeave = false) => {
  useEffect(() => {
    if (!isMeetingApp() || typeof wemeet === 'undefined') return;
    const originOverflow = document.documentElement!.style.overflow;
    document.documentElement!.style.overflow = 'auto';
    if (compareVersion(getAppVersion(navigator.userAgent), '3.19.1') > -1) {
      wemeet.ui.setScrollViewBounces?.({ enableBounces: false });
    }
    return () => {
      if (!resetOnLeave) return;
      document.documentElement!.style.overflow = originOverflow;
      if (compareVersion(getAppVersion(navigator.userAgent), '3.19.1') > -1) {
        wemeet.ui.setScrollViewBounces?.({ enableBounces: false });
      }
    };
  }, []);
};
